import React from 'react';
import svgTxSend from './icons/txsend.svg';
import svgTxRequest from './icons/txrequest.svg';
import svgRoundTick from './icons/round-tick.svg';
import svgRoundDismiss from './icons/round-dismiss.svg';

export enum SVGIcons {
  'Empty',
  'Flag',
  'Dismiss',
  'TxSend',
  'TxRequest',
  'RoundTick',
  'RoundDismiss',
}

const getPath = (nameY: SVGIcons, props: any) => {
  switch (nameY) {
    case SVGIcons.Flag:
      return (
        <g>
          <path
            // class="st0"
            d="M7.7,15.5l-7-13C0.5,2,0.6,1.4,1.1,1.1C1.6,0.9,2.2,1,2.5,1.5l7,13c0.2,0.5,0.1,1.1-0.4,1.4C8.6,16.1,8,16,7.7,15.5z"
          />
          <path
            {...props}
            // class="st1"
            d="M15.4,0.9c-1.9,4.6-5.5,2.7-7.5,6.2L4.7,1.6C7.6-2,12.5,1.8,15.4,0.9z"
          />
        </g>
      );
    case SVGIcons.Dismiss:
      return (
        <path
          {...props}
          d="M8,0C3.6,0,0,3.6,0,8s3.6,8,8,8s8-3.6,8-8S12.4,0,8,0z M11.5,10.1l-1.4,1.4L8,9.4l-2.1,2.1l-1.4-1.4L6.6,8L4.5,5.9l1.4-1.4L8,6.6l2.1-2.1l1.4,1.4L9.4,8L11.5,10.1z"
        />
      );
    case SVGIcons.TxSend:
      return svgTxSend.content;
    case SVGIcons.TxRequest:
      return svgTxRequest.content;
    case SVGIcons.RoundTick:
      return svgRoundTick.content;
    case SVGIcons.RoundDismiss:
      return svgRoundDismiss.content;
    default:
      return <path />;
  }
};

const getViewbox = (nameX: SVGIcons): string => {
  const viewbox = '0 0 16 16';
  switch (nameX) {
    case SVGIcons.TxSend:
      return svgTxSend.viewbox;
    case SVGIcons.TxRequest:
      return svgTxRequest.viewbox;
    case SVGIcons.RoundTick:
      return svgRoundTick.viewbox;
    case SVGIcons.RoundDismiss:
      return svgRoundDismiss.viewbox;
  }
  return viewbox;
};

interface Props {
  name: SVGIcons;
  style?: {};
  fill?: string;
  viewBox?: string;
  width?: string;
  className?: string;
  height?: string;
}

const SVGIcon: React.FC<Props> = (props) => (
  <svg
    width={props.width || '16px'}
    height={props.height || '16px'}
    style={props.style}
    className={props.className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={props.viewBox || getViewbox(props.name)}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    {getPath(props.name, { fill: props.fill || '#000' })}
  </svg>
);

export default SVGIcon;
